import { LeftArrow, RightArrow } from 'assests/GmsIcons';
import React from 'react';

type TArrowButtonProps = {
    onClick?: () => void;
    className?: string;
    direction?: 'left' | 'right';
}

const ArrowButton = ({ onClick, className, direction = 'left' }: TArrowButtonProps) => {
    const ArrowIcon = direction === 'left' ? LeftArrow : RightArrow;

    return (
        <button aria-label="Arrow"
            onClick={onClick}
            data-testid="rule-left-btn"
            type="button"
            /* Dark pass (okf/rules, 2026-09-08): the inline style block duplicated
               the classes below in literals (border #0747A6, background white) and
               beat every one of them — it is gone, and the classes carry the whole
               look on role tokens. The stray `aria-hidden="true"` literal INSIDE the
               className string (a class that never was) went with it. The icon's
               baked #0747A6 stroke follows the button ink via icon-follow-ink. */
            className={`
                icon-follow-ink
                tw-text-accent
                tw-w-6 
                tw-h-6
                tw-bg-surface 
                tw-border
                tw-border-solid
                tw-border-accent
                tw-rounded-md 
                tw-flex 
                tw-items-center 
                tw-justify-center 
                tw-shadow-ds-sm
                hover:tw-bg-surface-hover
                active:tw-bg-surface-sunken
                hover:tw-border-accent-hover
                active:tw-border-accent
                tw-transition-all
                tw-duration-200
                ${className || ''}
            `}
        >
            <ArrowIcon />
        </button>
    );
};

export const LeftButton = (props: Omit<TArrowButtonProps, 'direction'>) => (
    <ArrowButton {...props} direction="left" />
);

export const RightButton = (props: Omit<TArrowButtonProps, 'direction'>) => (
    <ArrowButton {...props} direction="right" />
);

export default ArrowButton;